import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DynamicContentOutletService } from './dynamic-content-outlet.service';

@Component({
  standalone: false,
  selector: 'ep-dynamic-content',
  template: `
    <div>
      <div #container></div>
    </div>
  `
})
export class DynamicContentOutletComponent implements OnDestroy, OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;

  private viewInitialized: boolean = false;
  private _type: string = null;

  @Input()
  set type(value: string) {
    if (value && value != '') {
      this._type = value;
      this.loadComponent();
      this.cdr.detectChanges();
    }
  }

  get type(): string {
    return this._type;
  }

  _pageSection: any = {};

  @Input() set pageSection(pageSection: any) {
    if (pageSection) {
      this._pageSection = pageSection;
      this.cdr.detectChanges();
    }
  }

  get pageSection() {
    return this._pageSection;
  }

  @Input()
  dynamicData: any;

  @Input()
  optional: boolean = false; //If the named component is missing from registry then don't try to load.

  private component: ComponentRef<{}>;

  constructor(private dynamicContentService: DynamicContentOutletService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.viewInitialized = true;
    this.loadComponent();
  }

  ngOnDestroy() {
    if (this.component) {
      this.component.destroy();
      this.component = null;
    }
  }

  async loadComponent() {
    if (this.viewInitialized == true) {
      this.container.clear();
      if (this.optional) {
        if (!this.dynamicContentService.getModuleInfoFromRegistry(this.type)) {
          //don't try to load component if "optional" input is set and component is not in the dynamic component registry
          return;
        }
      }

      if (this.type) {
        this.component = await this.dynamicContentService.GetComponent(this.type);
        this.container.insert(this.component.hostView);
        let instance = <any>this.component.instance;
        instance.pageSection = this.pageSection;
        instance.dynamicData = this.dynamicData;
        this.cdr.markForCheck();
      }
    }
  }
}
